export default {
  nav: {
    home: 'Home',
    course: 'Courses',
    setmeal: 'Packages',
    order: 'Orders',
    profile: 'Profile',
  },
  auth: {
    login: 'Login',
    phone: 'Phone',
    code: 'Verification Code',
    sendCode: 'Send Code',
    resend: 'Resend',
    loginBtn: 'Login',
    phonePlaceholder: 'Enter phone number',
    codePlaceholder: 'Enter verification code',
    loginSuccess: 'Login successful',
    agree: 'I agree to the',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
  },
  common: {
    loading: 'Loading...',
    noMore: 'No more data',
    networkError: 'Network error, please retry',
    back: 'Back',
    confirm: 'Confirm',
    cancel: 'Cancel',
    yuan: 'CNY',
    free: 'Free',
  },
}
